import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from './RunFixedIncomeForm.schema'

export interface RunFixedIncomeFormFieldsProps {}

export const RunFixedIncomeFormFields: React.FC<RunFixedIncomeFormFieldsProps> = ({}) => {
  const { control, setValue } = useFormContext<SchemaType>()
  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="value_date"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Report Date</FormLabel>
              <DatePicker
                selected={value ? new Date(value) : undefined}
                onSelect={(date) =>
                  date && setValue('value_date', toISO8601(date), { shouldValidate: true })
                }
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="value_date_mo"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Report Date - 1</FormLabel>
              <DatePicker
                selected={value ? new Date(value) : undefined}
                onSelect={(date) =>
                  date && setValue('value_date_mo', toISO8601(date), { shouldValidate: true })
                }
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
